import { render, staticRenderFns } from "./SkupCreate.vue?vue&type=template&id=2f3a3cad&scoped=true&"
import script from "./SkupCreate.vue?vue&type=script&lang=js&"
export * from "./SkupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3a3cad",
  null
  
)

export default component.exports